import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '@core';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { MoneyFormatPipe } from '@shared/pipe/money-format.pipe';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-scroll-search-affection',
    imports:[FormsModule,CommonModule,MoneyFormatPipe],
  templateUrl: './scroll-search-affection.component.html',
  styleUrl: './scroll-search-affection.component.scss'
})
export class ScrollSearchAffectionComponent {
 //Declaration de la variable d'emission des valeurs
@Output() onSelectAffection = new EventEmitter<any>();
@Input() cancelItemSelected : any;
@Input() showPrice : any;
@Input() defaultItem : any;
@Input() idMagasin : any;
@Input() disabledItem : boolean = false;
@Input() canCreateRupture : boolean = false;
@Input() hasSearchIdMedcoc : any;
@Input() is_garanti : any;
searchKeyMedoc: any = "";
  @Input() current_medicament_id: any;

  currentPage: number = 0;
  itemsPerPage: number = 10;
isDisabled : boolean = false;
itemToSearch: any = {};
itemToSave: any = {};
listItem: Array<any> = [];
user : any = {};
itemSelected : any = {};
canDisplay : boolean = false;

constructor(private authService: AuthService, private restClient: RestClientService,private utilities: UtilitiesService) {
  this.user = this.authService.currentUserValue;
}

getItems() {

  // On affiche le tableau des patients
  // if(this.hasSearchIdMedcoc && !this.idMagasin) {
  //   this.utilities.showNotification("snackbar-danger", "Veuillez sélectionner un magasin !",
  //   "bottom",
  //   "center");
  //   return;
  // }

  this.canDisplay = true;

  let request = {
    user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: this.itemsPerPage,
      // search_key: this.searchKeyMedoc,
      search_key: this.itemToSearch.searchText,
      data: {
        current_medicament_id: this.current_medicament_id,
        is_entente_prealable:this.is_garanti?0:undefined

      },
  }
    this.restClient.post('affection/getByCriteria', request)
      .subscribe(
        (res:any) => {
          if (res && res['items']) {
            this.listItem = res['items'];
            this.listItem.map(li=>{
              console.info('listItem: ')
              // li = li
              this.addStyleToTyped(li)
          })

          }
          else {
            this.listItem = [];
          }
        },
        err => {
        }
      );
  
 
}

onScroll(event: any) {
  // alert('hello')
    const element = event.target;
    const threshold = 50; // Trigger when 50px from bottom
    
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - threshold) {
      this.itemsPerPage =this.itemsPerPage+5;
      this.getItems()
    }
  }




selectedItem(item? : any){
  if(item){

    
    this.itemSelected = {...item};
    this.itemToSearch.searchText = this.itemSelected.libelle;
    console.info(" this.itemSelected ",this.itemSelected);
    console.log("this.itemToSearch.searchText: ",this.itemToSearch.searchText)

    
    // Brodcast de la valeur
    this.onSelectAffection.emit(this.itemSelected);

    // On ferme le tableau de selection des patients
    this.canDisplay = false;


    // On essai de faire l'enregistrement dans la table des ruptures 
    if(this.itemSelected && this.canCreateRupture) {

      console.info(" this.itemSelected?.dataMedicament?.seuilMedicament ",this.itemSelected?.dataMedicament?.seuilMedicament);
      console.info(" this.itemSelected?.quantiteStock ",this.itemSelected?.quantiteStock);
     
    }
    this.reinitValue()

  }else {
    if(!this.itemToSearch.searchText)  this.onSelectAffection.emit(null);
  }
}


reinitValue() {
  this.itemSelected = {};
  this.canDisplay = false;
  this.selectedItem(null);
  // this.itemToSearch.searchText = '';
}

ngOnInit(): void {
}


ngOnChanges(changes: SimpleChanges) {

  console.info(" changes ",changes);
  
  if(changes['cancelItemSelected'] && changes['cancelItemSelected'].currentValue)
  {
    this.itemSelected = {};
    this.itemToSearch.searchText = null;
  }

  if(changes['defaultItem'] && changes['defaultItem'].currentValue)
  {
    this.itemSelected = changes['defaultItem'].currentValue;

    if(changes['defaultItem'].currentValue && changes['defaultItem'].currentValue?.libelle) {
      this.itemToSearch.searchText = changes['defaultItem'].currentValue?.libelle;
    }else {
      this.itemToSearch.searchText = changes['defaultItem'].currentValue;
    }
  }

  if(changes['disabledItem'] && changes['disabledItem'].currentValue)
  {
    this.isDisabled = changes['disabledItem'].currentValue;
  }else {
    this.isDisabled = false;
  }
}

// addStyleToTyped(li: any) {
//   let libelle = li.libelle
//   let splited = libelle.split(this.itemToSearch.searchText.toUpperCase())
//   console.info('splited: ',splited);
//   //RENDRE DYNAMIQUE AU RANG N
//   let toReturn = ''
//   if(splited.length ==2)
//       toReturn +=splited[0]+`<strong>`+this.itemToSearch.searchText.toUpperCase()+`</strong>`+splited[1]
//   else{
//       for(let i=0;i<splited.length;i++){
//           if(splited[i+1])
//               toReturn +=splited[i]+`<strong>`+this.itemToSearch.searchText.toUpperCase()+`</strong>`+splited[i+1]
//           else
//               toReturn +=splited[i]+`<strong>`+this.itemToSearch.searchText.toUpperCase()+`</strong>`
//       }
//   }
//   console.info('toReturn: ',toReturn)
 
//   return li.styled = toReturn
// }


getMedicationStatusClass(item: any): string {
  if (item.is_exclu) {
    return 'excluded';
  } else if (item.is_entente_prealable) {
    return 'prior-agreement';
  } else {
    return 'available';
  }
}

// Update the addStyleToTyped method to handle better text highlighting
addStyleToTyped(li: any) {
  console.log('li: ',li)
  if (!this.itemToSearch.searchText) {
    return li.styled = li.libelle;
  }

  const libelle = li.libelle;
  const searchText = this.itemToSearch.searchText;
  
  // Create a case-insensitive regex to find all matches
  const regex = new RegExp(`(${searchText})`, 'gi');
  
  // Replace all matches with highlighted version
  let highlighted = libelle.replace(regex, '<strong>$1</strong>');
  if(this.showPrice){
  highlighted = highlighted+ ' ==> '+li.prix

  }
  return li.styled = highlighted;
}


}
